import api from '@/api'
import socket from '@/plugins/socket'

const state = {
  loading: false,
  refreshInterval: null
}

const getters = {
  loading: (state) => state.loading
}

const mutations = {
  SET_LOADING(state, isLoading) {
    state.loading = isLoading
  },

  SET_REFRESH_INTERVAL(state, func) {
    // Evitar múltiples intervalos activos
    if (state.refreshInterval) clearInterval(state.refreshInterval)
    state.refreshInterval = setInterval(func, 25000)
  }
}

const actions = {
  async init({ commit, dispatch /*, rootGetters */ }) {
    console.log('---INIT DATA---')
    commit('SET_LOADING', true)

    try {
      const promises = [
        // dispatch('usuario/userLoggedIn', null, { root: true }),
        // dispatch('map/fetchParamsComunidad', null, { root: true }),
        // dispatch('incendio/fetchIncendios', null, { root: true }),
        dispatch('incendio/fetchIncendiosReduced', null, { root: true }),
        dispatch('incendio/fetchTiposIncendioEstado', null, { root: true }),
        dispatch('incendio/fetchTiposIncendioNivel', null, { root: true }),
        dispatch('incendio/fetchTiposDeteccion', null, { root: true }),
        dispatch('medio/fetchMedios', null, { root: true }),
        dispatch('medio/fetchDispositivosHermes', null, { root: true }),
        dispatch('medio/fetchTiposMedio', null, { root: true }),
        dispatch('medio/fetchBases', null, { root: true }),
        dispatch('medio/fetchZonasMedio', null, { root: true }),
        dispatch('medio/fetchEmergencias', null, { root: true }),
        dispatch('medio/fetchComunidadesAutonomas', null, { root: true }),
        dispatch('medio/fetchServicios', null, { root: true }),
        dispatch('parametro/fetchParametros', null, { root: true }),
        dispatch('organismo/fetchOrganismos', null, { root: true }),
        dispatch('infraestructura/fetchTipos', null, { root: true }),
        dispatch('infraestructura/fetchInfraestructuras', null, { root: true }),
        dispatch('infraestructura/fetchCategorias', null, { root: true }),
        dispatch('infraestructura/fetchMunicipios', null, { root: true }),
        dispatch('demarcacion/fetchDemarcaciones', null, { root: true }),
        dispatch('infraestructura/fetchProvincias', null, { root: true }),
        dispatch('infraestructura/fetchOrganismos', null, { root: true })
      ]

      await Promise.all(promises)

      console.log('---LOADING DATA FINISHED---')

      // Ejecutar después de la carga inicial
      dispatch('usuario/userLoggedIn', null, { root: true })

      // INIT INTERVAL REFRESH
      commit('SET_REFRESH_INTERVAL', () => {
        const pendingRequests = api.request.pendingRequests

        // Solo lanzar si no hay ninguna petición en proceso
        if (pendingRequests === 0) {
          dispatch('incendio/fetchIncendiosReduced', null, { root: true })
          dispatch('medio/fetchMedios', null, { root: true })
          dispatch('parametro/fetchParametros', null, { root: true })
        }
      })
    } catch (error) {
      console.error(`Error init data ${error}`)
      this.notify('Error', 'Error al realizar la carga inicial de datos', 'error')
    } finally {
      commit('SET_LOADING', false)
    }
  },

  setLoading({ commit }, isLoading) {
    commit('SET_LOADING', isLoading)
  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
